import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const tag = {
    path: '/tags',
    component: Layout,
    name: 'tags',
    redirect: '/tags/index',
    children: [
      {
        path: '/tags/index',
        component: () => import('@/views/tag/index'),
        name: 'tags.index',
        meta: { title: i18n.t(`message.tags`)}
      },
    ]
  }

export default tag
